import api from '../client'

export const notificationsApi = {
  listIntegrations: async (organizationId) => {
    const response = await api.get(`/organizations/${encodeURIComponent(organizationId)}/notifications/integrations`)
    return response.data
  },
  createIntegration: async (organizationId, input) => {
    const response = await api.post(`/organizations/${encodeURIComponent(organizationId)}/notifications/integrations`, input)
    return response.data
  },
  updateIntegration: async (organizationId, integrationId, input) => {
    const response = await api.put(`/organizations/${encodeURIComponent(organizationId)}/notifications/integrations/${encodeURIComponent(integrationId)}`, input)
    return response.data
  },
  disableIntegration: async (organizationId, integrationId) => {
    const response = await api.post(`/organizations/${encodeURIComponent(organizationId)}/notifications/integrations/${encodeURIComponent(integrationId)}/disable`)
    return response.data
  },
  getStatus: async (organizationId) => {
    const response = await api.get(`/organizations/${encodeURIComponent(organizationId)}/notifications/status`)
    return response.data
  },
  retryDelivery: async (organizationId, deliveryId) => {
    await api.post(`/organizations/${encodeURIComponent(organizationId)}/notifications/deliveries/${encodeURIComponent(deliveryId)}/retry`)
  },
}
